import {SvgIcon} from "@material-ui/core";

export const CustomArrowDownIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 12 7" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M0.268029 0.998986C0.463291 0.803724 0.779873 0.803724 0.975135 0.998986L5.62158 5.64543L10.268 0.998986C10.4633 0.803724 10.7799 0.803724 10.9751 0.998986C11.1704 1.19425 11.1704 1.51083 10.9751 1.70609L5.97514 6.70609C5.77987 6.90135 5.46329 6.90135 5.26803 6.70609L0.268029 1.70609C0.0727665 1.51083 0.0727665 1.19425 0.268029 0.998986Z"/>
        </SvgIcon>
    )
}
